export const ONLY_DIGITS_WITH_DECIMALS = /^\d*\.?\d*$/;

export const ONLY_DIGITS = /^\d*$/;

export const INFO_REGEX =
  /^(?! )[A-Za-z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/;

export const ALL_ZEROS_REGEX = /^0*$/;

export const LEADING_ZEROS_REGEX = /^0*/;

export const WALLET_ADDRESS_REGEX = /^(0x[a-fA-F0-9]{40})$/;

export const FLOAT_OR_INTEGER_REGEX = /^-?\d*\.?\d*$/;
